import Icon from '@/components/ui/AppIcon';

interface Step {
  id: string
  number: string
  title: string
  description: string
  icon: 'MapPinIcon' | 'TruckIcon' | 'MapIcon'
}

const steps: Step[] = [
  {
    id: 'step_enter',
    number: '01',
    title: 'Find a Scooter',
    description: 'Open the app and locate nearby electric scooters on the map.',
    icon: 'MapPinIcon',
  },
  {
    id: 'step_choose',
    number: '02',
    title: 'Unlock & Ride',
    description: 'Scan the QR code to unlock. Helmet provided in the storage compartment.',
    icon: 'TruckIcon',
  },
  {
    id: 'step_track',
    number: '03',
    title: 'Park & End',
    description: 'Park in designated zones. End your ride in the app and pay automatically.',
    icon: 'MapIcon',
  },
]

export default function HowItWorks() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16 reveal">
          <span className="inline-block px-4 py-2 rounded-full bg-accent/10 text-accent text-sm font-body font-semibold mb-4">
            Simple Process
          </span>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-primary mb-4">
            How It Works
          </h2>
          <p className="text-lg text-muted-foreground font-body max-w-2xl mx-auto">
            Rent an electric scooter in just three easy steps. No complicated forms, no hidden fees.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 relative">
          {/* Connection Lines */}
          <div className="hidden md:block absolute top-20 left-1/4 right-1/4 h-0.5 bg-gradient-to-r from-secondary via-accent to-secondary" />

          {steps.map((step, index) => (
            <div
              key={step.id}
              className={`relative text-center reveal reveal-delay-${index * 100}`}
            >
              {/* Step Number Badge */}
              <div className="relative inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-secondary to-accent text-white text-2xl font-display font-bold mb-6 shadow-glow-md z-10">
                {step.number}
              </div>

              {/* Icon */}
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-muted mb-4">
                <Icon name={step.icon} size={32} className="text-primary" />
              </div>

              {/* Content */}
              <h3 className="text-xl font-display font-bold text-primary mb-2">
                {step.title}
              </h3>
              <p className="text-muted-foreground font-body">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12 reveal reveal-delay-300">
          <a
            href="/booking"
            className="btn-primary inline-flex items-center gap-2"
          >
            <Icon name="RocketLaunchIcon" size={20} />
            Find a Scooter
          </a>
        </div>
      </div>
    </section>
  )
}